/* eslint-disable @typescript-eslint/no-unused-vars */
import ManagerRepository from 'coreClasses/ManagerRepository';
import {IDataLayerEvent} from '../IGoogleTagManager';
import {IEventData} from 'coreClasses/events/IEvents';

/**
 * Represents EventModel
 */
export default class EventModel implements IDataLayerEvent {
	public managerRepository: ManagerRepository;
	public event: string;

	/**
	 * @constructor
	 * @param {ManagerRepository} managerRepository - ManagerRepository instance
	 * @param {IEventData} data - data
	 */
	constructor(managerRepository: ManagerRepository, data: IEventData) {
		this.managerRepository = managerRepository;

		if (data?.event) {
			this.event = data.event;
		}
	}

	/**
	 * Is persistent Event
	 * @returns {boolean} is should be saved
	 */
	public isPersistentEvent() {
		return false;
	}

	/**
	 * Checks if event should be keep
	 * @param {EventModel} previousEvent - previous event
	 * @returns {boolean} is should be keep
	 */
	public isEventShouldBeKept(previousEvent) {
		return false;
	}

	/**
	 * Is independent event and should not wait for other
	 * @returns {boolean} is independent event
	 */
	public isIndependentEvent() {
		return false;
	}
};
